import type { LockInfo } from '/#/store'

import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

import { LOCK_INFO_KEY } from '/@/enums/cacheEnum'
import { Persistent } from '/@/utils/cache/persistent'

export const useLockStore = defineStore('app-lock', () => {
  // State
  const lockInfo = ref<Nullable<LockInfo>>(Persistent.getLocal(LOCK_INFO_KEY))

  // Getters
  const getLockInfo = computed(() => lockInfo.value)

  // Actions
  function setLockInfo(info: LockInfo) {
    lockInfo.value = Object.assign({}, lockInfo.value, info)
    Persistent.setLocal(LOCK_INFO_KEY, lockInfo.value, true)
  }

  function resetLockInfo() {
    Persistent.removeLocal(LOCK_INFO_KEY, true)
    lockInfo.value = null
  }

  // Unlock
  async function unLock(password?: string) {
    if (lockInfo.value?.pwd === password) {
      resetLockInfo()
      return true
    }
    // 项目不需要登录，直接解锁
    resetLockInfo()
    return true
  }

  return {
    lockInfo,
    getLockInfo,
    setLockInfo,
    resetLockInfo,
    unLock,
  }
})
